import React from "react";
import ResetPasswordForm from "../components/ResetPasswordForm/ResetPasswordForm";
import CheckEmailBox from "../components/CheckEmailBox/CheckEmailBox";
import GridLGHidden from "../components/GridComponent/components/GridLGHidden";
import Header from "../components/Header/Header";
import GridComponent from "../components/GridComponent/GridComponent";
import { LeftSideComponent } from "../components/Sidebar/Sidebar";
import GridTitle from "../components/GridComponent/components/GridTitle";
import { useNavigate } from "react-router-dom";

const ForgotPassword: React.FC = () => {
  const [showCheckEmail, setShowCheckEmail] = React.useState(false);

  return (
    <div className="flex flex-col lg:flex-row bg-[#F5F5FC] lg:bg-transparent">
      <GridLGHidden>
        <Header backgroundColor="[#F5F5FC]" />
      </GridLGHidden>
      <GridComponent
        leftSideComponent={<LeftSideComponent />}
        containerClassNames={"lg:grid-cols-grid-chat-no-right-lg"}
        mainComponent={<MainComponent setShowCheckEmail={setShowCheckEmail} />}
        mainComponentContainerClassNames="!overflow-hidden"
      />
      {showCheckEmail && (
        <div className="w-full bg-modal-overlay  h-[100svh] justify-center items-center flex absolute top-0 left-0 z-50">
          <div className="lg:max-w-[700px] lg:h-svh flex items-center justify-center w-full">
            <CheckEmailBox backBtnClick={() => setShowCheckEmail(false)} />
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPassword;

const MainComponent = ({
  setShowCheckEmail,
}: {
  setShowCheckEmail: (value: boolean) => void;
}) => {
  const navigate = useNavigate();

  return (
    <div className="flex flex-1 flex-col lg:h-svh pb-[80px] lg:pb-0">
      <GridTitle
        title="Forgot password?"
        backBtnClick={() => navigate("/account-details")}
      />
      <div className="lg:bg-white rounded-20 flex-1 h-full overflow-hidden lg:pr-24 lg:py-24 mb-24">
        <div className="lg:px-24 px-0 mt-24 lg:overflow-auto h-full pb-36 flex flex-col justify-between">
          <ResetPasswordForm setShowCheckEmail={setShowCheckEmail} />
        </div>
      </div>
    </div>
  );
};
